import React, { useState } from 'react';
import { Button, message } from 'antd';
import { Download } from 'lucide-react';
import { ValuationApi } from '../../apis';
import { downloadPDF } from '../../utils';

type Props = {
  payload: { id: string; status: string };
  hasAccess: boolean;
};


export const ValuationPdfDownload = ({ payload, hasAccess }: Props) => {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const canDownload = hasAccess && payload.status === 'VALUATED';

  const download = async () => {
    if (!canDownload || loading) return;
    setLoading(true);
    try {
      const report = await ValuationApi.pdf(payload.id);
      downloadPDF(report.url);
    } catch (error: any) {
      messageApi.error(error?.message || 'PDF татахад алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  if (!canDownload) return null;

  return (
    <>
      {contextHolder}
      <div className="h-[99px] w-[100%] absolute border z-[100] bottom-0 left-0 bg-[white] flex flex-row justify-end items-center pr-[21px] gap-[20px]">
        <Button type="primary" size="large" loading={loading} onClick={download}
          icon={<Download className="w-[20px] h-[20px]" />}>
          PDF татах
        </Button>
      </div>
    </>
  );
};
